import React, { ReactChild } from "react";
import { Link, RouteComponentProps } from "react-router-dom";
import { StaticContext } from "react-router";

interface DrawerToggleProps
    extends RouteComponentProps<{}, StaticContext, { to: { pathname: string; state?: { vin?: string } } }> {
    children: ReactChild;
    className?: string;
    isCurrentlyOpen: boolean;
    path: { pathname: string; state?: any };
    title?: string;
    toggleGPC: () => void;
}
const DrawerToggle: React.FunctionComponent<DrawerToggleProps> = (props) => {
    const { children, className, isCurrentlyOpen, location, path, title, toggleGPC } = props;

    // Leaves the drawer open if a user is moving from the GPC to the TradeIn component.
    const handleToggle = (to: { pathname: string }) => () => {
        if (to.pathname === "/my-garage" && isCurrentlyOpen) {
            toggleGPC();
            return;
        }

        // If the drawer is closed, always open it.
        if (!isCurrentlyOpen) {
            toggleGPC();
            return;
        }

        // If the same path is being clicked as where we are, close the drawer.
        const differentLocation = to.pathname !== location.pathname;
        if (!differentLocation) {
            toggleGPC();
            return;
        }
    };

    return (
        <Link to={path} onClick={handleToggle(path)} className={className} title={title}>
            {children}
        </Link>
    );
};

export default DrawerToggle;
